import Vue from 'vue'
import store from './store'
import animated from 'animate.css';
Vue.use(animated);
import 'wowjs/css/libs/animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/iconfont/iconfont.css"
Vue.use(ElementUI);
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import {message} from "./utils/elementuiEdit"
Vue.use(Vant);
Vue.use(VueAwesomeSwiper)
Vue.prototype.$message = message
// 浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '1147291d80783291a3a95280a2a22a8e',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
import App from './App.vue'
import router from './router'
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if ((navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  ))) {
    if (to.name.substring(0, 1) == "m") {
      next()
    } else {
      next(from.path)
    }
  } else {
    if (to.name.substring(0, 1) != "m") {
      next()
    } else {
      next(from.path)
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
